import LinkGalleryUI, { Props as UIProps } from '@interflora/ui-components/build/components/LinkGallery/LinkGallery'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

type Props = UIProps

const LinkGallery = (props: Props) => {
  const analytics = useAnalytics()

  const sendLinkGalleryTextAnalytics = (linkText: string) => {
    analytics.sendLinkGalleryTextAnalytics(linkText)
  }

  useLoaded(props)

  return <LinkGalleryUI {...props} sendLinkGalleryTextAnalytics={sendLinkGalleryTextAnalytics} />
}

export default LinkGallery
